var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kanban-board-wrapper"},[(_vm.boardData)?_c('KanbanBoard',{attrs:{"buckets":_vm.boardData.buckets,"board-title":_vm.boardData.title}}):_c('div',{staticClass:"loading-container"},[_c('p',[_vm._v("Loading board...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }